const _idSeq = [], _createId = () => {
    const len = _idSeq.length;
    for (let i = 0; i < len; ++i) {
        if (_idSeq[i]) {
            continue;
        }
        _idSeq[i] = true;
        return i;
    }
    _idSeq.push(true);
    return len;
}, _claimId = (routeId) => {
    if (_idSeq[routeId]) {
        return;
    }
    const len = _idSeq.length;
    if (routeId >= len) {
        for (let i = len; i < routeId; ++i) {
            _idSeq[i] = false;
        }
    }
    _idSeq[routeId] = true;
}, _freeId = (routeId) => {
    const lastIndex = _idSeq.length - 1;
    if (routeId === lastIndex) {
        _idSeq.pop();
        for (let i = lastIndex - 1; i >= 0; --i) {
            if (_idSeq[i]) {
                break;
            }
            _idSeq.pop();
        }
    }
    else {
        _idSeq[routeId] = false;
    }
};
export { _createId, _claimId, _freeId, };
